import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title = "SBF Home Improvements LLC - Professional Home Improvement Services in Fayette County, PA",
  description = "Quality roofing, siding, flooring, deck construction, and home repairs in Fayette County (15666) and surrounding 20-mile radius. Licensed & insured (PA #159448). Call (724) 420-6192 for free estimates.",
  keywords = "home improvement 15666, roofing contractor Fayette County, siding installation Mt Pleasant PA, deck builder Scottdale, flooring installation Connellsville, home repairs Uniontown, licensed contractor PA 15666, Westmoreland County contractor",
  ogImage = "https://customer-assets.emergentagent.com/job_home-fix-experts-2/artifacts/g7c6skmt_logo7_22_15505.jpeg",
  ogUrl = typeof window !== 'undefined' ? window.location.origin : "https://www.sbfhomeimprovements.com"
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "SBF Home Improvements LLC",
    "image": ogImage,
    "description": description,
    "telephone": "+17244206192",
    "email": "sbfhomeimprovements20@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Mt Pleasant",
      "addressRegion": "PA",
      "postalCode": "15666",
      "addressCountry": "US"
    },
    "areaServed": [
      {
        "@type": "GeoCircle",
        "geoMidpoint": {
          "@type": "GeoCoordinates",
          "latitude": "40.1456",
          "longitude": "-79.5414",
          "name": "Mt Pleasant, PA 15666"
        },
        "geoRadius": "20 miles"
      },
      {
        "@type": "City",
        "name": "Fayette County, PA 15666"
      },
      {
        "@type": "City", 
        "name": "Mt Pleasant, PA"
      },
      {
        "@type": "City",
        "name": "Scottdale, PA"
      },
      {
        "@type": "City",
        "name": "Connellsville, PA"
      },
      {
        "@type": "City",
        "name": "Uniontown, PA"
      },
      {
        "@type": "City",
        "name": "Westmoreland County, PA"
      }
    ],
    "priceRange": "$$",
    "openingHours": "Mo-Fr 07:00-18:00, Sa 08:00-16:00",
    "sameAs": [],
    "hasCredential": {
      "@type": "EducationalOccupationalCredential",
      "credentialCategory": "license",
      "recognizedBy": {
        "@type": "Organization",
        "name": "Pennsylvania"
      },
      "identifier": "159448"
    }
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={ogUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content="SBF Home Improvements LLC" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={ogUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="English" />
      <meta name="author" content="SBF Home Improvements LLC" />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="US-PA" />
      <meta name="geo.placename" content="Mt Pleasant, PA 15666" />
      <meta name="geo.position" content="40.1456;-79.5414" />
      <meta name="ICBM" content="40.1456, -79.5414" />
    </Helmet>
  );
};

export default SEO;